module.exports = __webpack_public_path__ + "static/media/header-samplings.7a095f98.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/samplings/header-samplings.png
// module id = 698
// module chunks = 0